import React from 'react';
import { LinearProgress, Rating } from '@mui/material';
import { Col, Modal, Row } from 'react-bootstrap';
import { getSessionStorageItem, SESSION_STORAGE_ACCOUNT_KEY } from '../../../sessionStorage';
import StarIcon from '../../Helpers/Svg/StarIcon';
import { handleStarRating } from './TestimonialHandler';
import './TestimonialGraphicModal.scss';

export default function TestimonialGraphicModal(props) {
    const accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);
    const testimonialPanelHeader = accountObj && accountObj.account && accountObj.account.testimonialPanelHeader ? accountObj.account.testimonialPanelHeader : 'Our members love their life insurance experience!';
    
    const ratings = [
        { star: 5, percentage: 79.7 },
        { star: 4, percentage: 11.1 },
        { star: 3, percentage: 4.9 },
        { star: 2, percentage: 1.1 },
        { star: 1, percentage: 3.2 },
    ];

    const RatingBar = ({ value, percentage}) => (
        <Row className='progress-div mb-1'>
            <Col sm={2} xs={3} className='progress-star'>{value}-Star</Col>
            <Col sm={8} xs={7} className="px-0 linear-progress-div">
                <LinearProgress value={percentage} variant="determinate" />
            </Col>
            <Col sm={2} xs={2} className='progress-percentage'><span>{`${percentage}%`}</span></Col>
        </Row>
    );

    return (
        <Modal show={props.show} onHide={props.onHide} onClose={props.onHide} backdrop="true" scrollable={true} className='testimonial-graphic-modal' size='md' centered>
            <Modal.Header closeButton className='pb-0'>
                <Modal.Title className='modal-title'>
                    <h3 className='header-div'>
                        {testimonialPanelHeader}
                    </h3>
                    <hr className='ms-3' />
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className='pt-0 text-center'>
                <div className="star-rating-panel-modal">
                    <Rating size="large" readOnly className="star-rating-icon" defaultValue={Number(handleStarRating(props.avgStarRating))} precision={0.1} emptyIcon={<StarIcon fontSize="inherit" className='empty-star' />} />
                    <h5 className='star-title'>
                        {props.avgStarRating} out of 5 stars
                    </h5>
                </div>
                <p className="panel-subtitle">
                    632 customer satisfaction surveys
                </p>
                <div className='mt-2 text-center'>
                    {ratings.map((x, index) => (
                        <RatingBar key={index} value={parseInt(x.star, 10)} percentage={x.percentage} />
                    ))}
                </div>
            </Modal.Body>
        </Modal>
    )
}
